import {loader_action} from "../actions/preloader";

const inited = {
    display: false,
    message: '데이터를 처리중입니다.'
};

export default function preloaderReducer(state = inited, action) {
    switch (action.type) {
        case loader_action:
            return {
                ...state,
                ...(action.hasOwnProperty('payload') ? action.payload : inited)
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/libs/redux/reducres/preloader.js